
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SubmissionForm from './components/SubmissionForm';
import SubmissionGuidelines from './components/SubmissionGuidelines';

export default function Submit() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <section className="py-16 px-6 lg:px-8 bg-gray-900 text-white">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl font-bold mb-6" style={{ fontFamily: '"Libre Baskerville", serif' }}>
              Submit Your Work
            </h1>
            <p className="text-xl text-gray-300 leading-relaxed">
              Share your voice with Canada's literary community. We welcome submissions of poetry, 
              short fiction, essays, and book reviews from writers across the nation.
            </p>
          </div>
        </section>
        
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <SubmissionGuidelines />
            <SubmissionForm />
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
